import React from 'react';
import { QrScanChecklistModal } from '@/common/QrScan';

/**
 * Sieve/Screen-specific scan-against-target-list modal.
 *
 * Props match the original implementation so the caller in SieveAllocation
 * needs no changes. All scanning UX is delegated to QrScanChecklistModal.
 */
const SieveScanModal = ({
  visible,
  onCancel,
  onConfirm,
  targetLabels = [],
  title = 'Scan Sieve/Screen Items',
  confirmButtonText = 'Confirm',
  loading = false,
  // eslint-disable-next-line no-unused-vars
  scannerId
}) => (
  <QrScanChecklistModal
    visible={visible}
    onCancel={onCancel}
    onConfirm={onConfirm}
    targetLabels={targetLabels}
    title={title}
    confirmButtonText={confirmButtonText}
    loading={loading}
    noun={{ singular: 'item', plural: 'items' }}
    manualPlaceholder="Type sieve label manually (e.g. SV-123)"
  />
);

export default SieveScanModal;
